export default __webpack_public_path__ + "static/media/problem-icon.7d8d8ce2.png";